// This file was automatically generated from appchart.dialog.allergyHx.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.allergyHx');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptIntolerances');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.allergyHx.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><ul class="el8ButtonContainer el8ItemButtonWrapRight mv5"><li class="el8ButtonItem mr10"><button type="button" class="el8button add-allergy-trigger el8ItemButton">+ Add Allergy</button></li><li class="el8ButtonItem"><button type="button" class="el8button add-intol-trigger el8ItemButton">+ Add Drug Intolerance</button></li></ul><h4 class="el8SectionHeaderNoCollapse">Active Allergies</h4><ol class="active-allergies-section el8LHSSubSection"></ol><h4 class="el8SectionHeaderNoCollapse mt20">Inactive Allergies</h4><ol class="inactive-allergies-section el8LHSSubSection"></ol><h4 class="el8SectionHeaderNoCollapse mt20">Active Drug Intolerances</h4><ol class="active-intols-section el8LHSSubSection"></ol><h4 class="el8SectionHeaderNoCollapse mt20">Inactive Drug Intolerances</h4><ol class="inactive-intols-section el8LHSSubSection"></ol><div class="padb50"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.allergyHx.allergyList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    output.append('<li class="el8ItemHover allergyNone more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
    el8.template.ptdata.ptAllergies.documentedAsNoneSummary(null, output);
    output.append('</p></li>');
  } else {
    if (! opt_data.allergies.length) {
      output.append('<li class="el8SectionEmpty">None</li>');
    } else {
      var aList1195 = opt_data.allergies;
      var aListLen1195 = aList1195.length;
      for (var aIndex1195 = 0; aIndex1195 < aListLen1195; aIndex1195++) {
        var aData1195 = aList1195[aIndex1195];
        el8.template.appchart.dialog.allergyHx.allergy(aData1195, output);
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.allergyHx.intolList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    output.append('<li class="el8ItemHover intolActive more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
    el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    output.append('</p></li>');
  } else {
    if (! opt_data.intols.length) {
      output.append('<li class="el8SectionEmpty">None</li>');
    } else {
      var iList1209 = opt_data.intols;
      var iListLen1209 = iList1209.length;
      for (var iIndex1209 = 0; iIndex1209 < iListLen1209; iIndex1209++) {
        var iData1209 = iList1209[iIndex1209];
        el8.template.appchart.dialog.allergyHx.intolerance(iData1209, output);
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.allergyHx.allergy = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="el8ItemHover allergy', soy.$$escapeHtml(opt_data.status), ' more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYrMMDD el8AppText el8NormalText', (! opt_data.startDate) ? ' el8AlignCenter' : '', '">', (opt_data.startDate) ? (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') : '--', '</div><p class="el8ItemWithDate"><span class="el8Preserve" data-id="', soy.$$escapeHtml(opt_data.id), '">');
  el8.template.ptdata.ptAllergies.summary(opt_data, output);
  output.append('</span><span class="ml5 el8SystemText">last modified on ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.createDate)) : ''), '</span></p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.allergyHx.intolerance = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="el8ItemHover intol', soy.$$escapeHtml(opt_data.status), ' more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton">Actions<span class="el8ButtonDropdownIcon"></span></button></div><div class="el8DateYrMMDD el8AppText el8NormalText', (! opt_data.startDate) ? ' el8AlignCenter' : '', '">', (opt_data.startDate) ? (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') : '--', '</div><p class="el8ItemWithDate"><span class="el8Preserve" data-id="', soy.$$escapeHtml(opt_data.id), '">');
  el8.template.ptdata.ptIntolerances.summary(opt_data, output);
  output.append('</span><span class="ml5 el8SystemText">last modified ', (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.createDate)) : ''), '</span></p></li>');
  if (!opt_sb) return output.toString();
};
